// extracted by mini-css-extract-plugin
export default {"name":"toClientProfileBtn_name__grHkk","nameBtn":"toClientProfileBtn_nameBtn__bkYrS"};